<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-healthpicks-operator-login></app-healthpicks-operator-login>
  </div>

  <!-- <div *ngIf="page === 'register'">
    <app-healthpicks-operator-register></app-healthpicks-operator-register>
  </div> -->

  <div *ngIf="page === 'forgot-password'">
    <app-healthpicks-operator-forgot-password></app-healthpicks-operator-forgot-password>
  </div>


  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-healthpicks-operator-change-password-sent></app-healthpicks-operator-change-password-sent>
  </div>

  <!-- <app-healthpicks-operator-register-resend
    *ngIf="page === 'register-resend'"
  ></app-healthpicks-operator-register-resend> -->
</ng-container>
